<template>
	<el-dialog v-model="isVisible" @closed="onClosed" width="700">
		<h3>
			<span>{{ partNumber?.toLocaleUpperCase() }}</span>
		</h3>
		<el-table 
			v-loading="searchOperaionPending"  
			:data="items"
			:show-header="false"
			max-height="300"
			@row-click="selectItemFromSearchResultsClick">			
			<el-table-column label="Номер OEM" width="140" prop="partNumber" />
			<el-table-column prop="externalName" label="Наименование" />
			<el-table-column prop="manufacturer.name" label="Производитель" />
		</el-table>
	</el-dialog>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { ElTag } from 'element-plus';
import { WatchStopHandle, watch } from 'vue';
import ItemModel from '@/models/ItemModel';

@Options({	
	components: {
		ElTag
	},
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		partNumber: {
			type: String,
			default: null
		},
		items: {
			type: Array,
			default: null
		}
	},
	emits: ["update:visible"],
})
export default class SearchItemsByPartNumberComponent extends Vue {
	/** props */
	items!: Array<ItemModel>;
	visible!: boolean;
	partNumber!: string;

	/** models */
	isVisible = false;
	searchOperaionPending = false;

	visibleSubscription!: WatchStopHandle;

	mounted() {
		this.visibleSubscription = watch(
			() => this.visible,
			(v: boolean) => {
				this.isVisible = v;
				if (!this.isVisible) {					
					this.$emit('update:visible', false);
				}
			}
		);
	}

	unmounted() {
		if (this.visibleSubscription) {
			this.visibleSubscription();
		}
	}

	onClosed() {
		this.$emit('closed');
	}

	selectItemFromSearchResultsClick(item: ItemModel) {
		this.isVisible = false;
		this.$emit('itemSelected', item);
	}
}
</script>

<style scoped>
	h3 {
		margin: -1.6rem 0 .33rem .33rem;
		max-width: 88%;
		text-overflow: clip;
		overflow: hidden;
		text-wrap: nowrap;
	}
</style>